import React, { useEffect, useRef, useState } from 'react'
import { Row, Col, Badge, Button, Form, textarea } from 'react-bootstrap'
import { ReactComponent as ChartIcon } from "../../../assets/images/icon_svg/blue_chart.svg";
import { ReactComponent as AI_Icon } from "../../../assets/images/icon_svg/ai_icons.svg";
import { ReactComponent as ChartDwnld } from "../../../assets/images/icon_svg/chart_dwnld.svg";
import { CallApi, getTodayDate } from '../../../Components/common/CommonFunctions';
import axios from 'axios';

const ChartGenerator = ({ orgId }) => {

  const isMounted = useRef(false);
  const [generate, setGenerate] = useState()
  const [isLoading, setIsLoading] = useState(false);
  const [text, setText] = useState('');
  const fetchGenerate = async () => {
    setIsLoading(true)
    try {
      const token = localStorage.getItem('airlinetoken');

      const res = await axios.post('https://cdmai.trucking.aero/serreco',
        {
          org_id: orgId,
          // chart_type: "bar",
          question: text
          // question: "Open cases per region"
        },
        {
          headers: {
            'Content-Type': 'application/json',
            // 'Authorization': `Bearer ${token}`
          }
        }
      );
      const innerData = res.data?.blob;
      setGenerate(innerData)
      setIsLoading(false)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    // fetchGenerate()
    isMounted.current = true;
  }, [])

  const handleAddText = (value) => {
    // setText((prev) => prev ? `${prev} ${value}` : value);
    setText(value);
  };

  const downloadChart = () => {
    const link = document.createElement('a');

    link.href = `data:image/png;base64,${generate}`;
    link.download = `AI-Chart-${getTodayDate()}.png`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {isLoading &&
        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
      }

      <div className='chartGeneratorDv mt-5'>

        <div className='kpiChart_card'>
          <div className='d-flex'>
            <div className='chartIcon'>
              <ChartIcon />
            </div>
            <div>
              <h4 className='d-flex align-items-center gap-3'>Generate KPI Chart <span className='betaBadge'>Beta</span></h4>
              <p>Ask a question about your recovery data and generate a chart.</p>
            </div>

          </div>
          <div className='mb-3'>
            <Form>
              <Form.Control
                as="textarea"
                rows={4}
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Example : Show open recovery cases by irregularity type for region Europe"
              />
            </Form>
          </div>
          <div className='exmple_promptDv'>
            <h6>Example prompts:</h6>
            <div className='d-xxl-flex justify-content-between align-items-center'>
              <div className='exmple_propmtsBtn d-flex gap-2'>
                <Button variant="none" onClick={() => handleAddText('Open cases by region')}>Open cases by region</Button>
                <Button variant="none" onClick={() => handleAddText('Open cases by irregularity type')}>Open cases by irregularity type</Button>
                <Button variant="none" onClick={() => handleAddText('Open cases by priority')}>Open cases by priority</Button>
                {/* <Button variant="none" onClick={() => handleAddText('Cases per action status per region')}>Cases per action status per region</Button> */}
              </div>

              <div className='d-flex gap-3'>
                <Button variant="none" className='handleStsBtn mb-0 align-items-center' onClick={() => setText('')}>Clear</Button>
                <Button variant="none" className='AI_btn' onClick={fetchGenerate}><AI_Icon className='me-2' />Generate Chart</Button>
              </div>

            </div>
          </div>

        </div>
        <div className='kpiChart_card chrt_dv'>
          <div className='d-flex align-items-center mb-3'>
            <div>
              <h4 className='mb-0'>Generate KPI Chart</h4>
            </div>
            <div className='ms-auto'>
              <Button variant="none" className={`dwnld_btn ${generate ? 'dwnld_btn_active' : ''}`} onClick={downloadChart}>
                <ChartDwnld className='me-2' />Download Image
              </Button>
            </div>
          </div>
          <div>
            <div className='chart_generatedDv'>
              {generate ?
                <img src={`data:image/png;base64,${generate}`} />
                :
                <>
                  <div className='chartIcon'>
                    <ChartIcon />
                  </div>
                  <div className='text-center'>
                    <h4>Your generated chart will appear here</h4>
                    <p>Ask a question and click “Generate Chart” to visualize your data.</p>
                  </div>
                </>
              }

            </div>

          </div>
        </div>

      </div>
    </>
  )
}

export default ChartGenerator